module.exports = __webpack_public_path__ + "static/favicon-f38e65ae2d4805bd6ce4f0044582e9f2.png";